import React from "react";
import { connect } from "react-redux";
import { Div } from "components/Base";
import { getters as TabsGetters } from "Portal/Tabs";
import Tasks from "./Tasks";
import {
  filteredTabs,
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize
} from "../selectors";

import Tabs from "Portal/Tabs/View";

const decorate = connect((state, props) => ({
  selectedTab: TabsGetters.selectedTab(state, props),
  tabs: filteredTabs(state),
  sectionHeaderColor: getSectionHeaderColor(state),
  sectionHeaderFont: getSectionHeaderFont(state),
  sectionHeaderSize: getSectionHeaderSize(state)
}));

const Activities = ({
  tabs,
  tasksRef,
  sectionHeaderColor,
  sectionHeaderFont,
  sectionHeaderSize
}) => (
  <Div
    bg="#f2f2f2"
    style={{
      borderRadius: 10,
      padding: "10px 20px",
      marginBottom: "40px"
    }}
  >
    <Tabs
      tabs={tabs}
      mb={4}
      titleStyle={{
        color: sectionHeaderColor,
        fontFamily: sectionHeaderFont,
        fontSize: sectionHeaderSize
      }}
    />
    <Div>
      <Tasks tasksRef={tasksRef} />
    </Div>
  </Div>
);

export default decorate(Activities);
